/* eslint-disable react-native/no-color-literals */
import React, { FC } from 'react';
import { ElementType, exitWalkthrough, goToWalkthroughElementWithId, nullElement } from "react-native-walkthrough"
import { View } from 'native-base';
import { Text } from "../components/text/text"
import { Appearance, Dimensions, TouchableOpacity, ViewStyle } from "react-native"
import { Button, JalaIcon } from "../components"
import { translate } from "../i18n"
import { FarmStoreModel } from "../models/app-store/farm-store/farm-store"
import { getRootStore } from "../utils/root-store"
import { color } from '../theme';
import JalaAnalytic from "../utils/jala-analytic"

const CLOSE_ICON: ViewStyle = {
  marginLeft: 5,
  width: "10%",
  alignItems: "flex-end"
}

const Content: FC<{
  colorScheme?: "light"|"dark",
  text: string,
  order?: number,
  total?: number,
  nextText?: string,
  onNext?: () => void,
  onExit?: () => void
}> = function Content(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    text, order, total, nextText, onNext, onExit
  } = props

  return <View>
    <View flexDirection="row" alignItems="flex-start" justifyContent="space-between">
      <View width="90%">
        <Text text={text} preset="textBase" marginBottom="8px" colorScheme={colorScheme}  />
      </View>
      <TouchableOpacity onPress={onExit} style={CLOSE_ICON}>
        <JalaIcon name="close" size={20} color={color.palette.gray800} />
      </TouchableOpacity>
    </View>
    <View flex={1} height="30px" flexDirection="row" alignItems="center" justifyContent="space-between">
      <Text text={`${order}${total ? `/${total}` : ''}`} preset="xs" colorScheme={colorScheme} />
      <Button
        testID="jala:id/next-button"
        text={nextText || translate("common.next")}
        textPreset="caption1"
        preset="link"
        colorScheme={colorScheme}
        onPress={onNext}
      />
    </View>
  </View>
}

export default (onExit?: () => void) => {
  const {
    appStore: { farmStoreModels = [], farmStore },
    userStore,
    userStore: { hasManagementInterest }
  } = getRootStore()
  const { pondStoreModels = [], activePondStores = [] } = farmStore || FarmStoreModel.create({})
  const width = Dimensions.get('window').width;
  const overviewContent =
    (!farmStoreModels.length && translate('onboardModal.welcomeOverviewCreateSomething', { something: translate('farms.singular') })) ||
    (!pondStoreModels.length && translate('onboardModal.welcomeOverviewCreateSomething', { something: translate('ponds.singular') })) ||
    (!activePondStores.length && translate('onboardModal.welcomeOverviewCreateSomething', { something: translate('cycles.singular') })) ||
    translate("onboardModal.welcomeOverview")

  return [
    (hasManagementInterest && activePondStores.length ? {
      id: 'overview-section',
      content: overviewContent,
      placement: 'bottom',
    } : null),
    (!hasManagementInterest ? {
      id: 'banner-section',
      content: translate("onboardModal.welcomeBanner"),
      placement: 'bottom',
    } : null),
    (!hasManagementInterest ? {
      id: 'menu-section-bottom',
      content: translate("onboardModal.welcomeMenuOther"),
      placement: 'bottom',
    } : null),
    {
      id: 'tab-bar-quick-input',
      content: translate("onboardModal.welcomeQuickInput"),
      placement: 'top',
    },
    {
      id: 'monitoring-section',
      placement: 'bottom',
      content: translate("onboardModal.welcomeMonitoring"),
      tooltipProps: {
        tooltipStyle: { left: 24, right: null },
        arrowStyle: { left: (0.5 * width / 5) - 9 - 24 }
      },
    },
    {
      id: 'menu-section',
      content: translate("onboardModal.welcomeMenu"),
      placement: 'bottom',
    },
    (hasManagementInterest && !activePondStores.length ? {
      id: 'farm-and-overview-section',
      content: overviewContent,
      placement: 'bottom',
      tooltipProps: { allowChildInteraction: true }
    } : null),
  ].filter((v) => v).map((value, index, array) => ({
    ...value,
    tooltipProps: {
      allowChildInteraction: false,
      ...((index < (array.length - 1)) ? {} : { onClose: () => undefined }),
      tooltipStyle: { left: 0, right: 0, marginLeft: 'auto', marginRight: 'auto' },
      ...value.tooltipProps
    },
    content: <Content
      text={value.content}
      order={index + 1}
      total={array.length}
      nextText={!array[index + 1] ? translate('common.done') : undefined}
      onNext={() => {
        if (array[index + 1]) {
          JalaAnalytic.log('Mobile App: Home Coachmark - next', { id: value.id })
          goToWalkthroughElementWithId(array[index + 1]?.id || nullElement.id)
        }
        else {
          userStore.set("isCoachmarkRunning", false)
          JalaAnalytic.log('Mobile App: Home Coachmark - finish', { id: value.id })
          onExit && onExit()
          exitWalkthrough()
        }
      }}
      onExit={() => {
        userStore.set("isCoachmarkRunning", false)
        JalaAnalytic.log('Mobile App: Home Coachmark - finish', { id: value.id })
        onExit && onExit()
        exitWalkthrough()
      }}
    />
  })) as Array<ElementType>;
}
